<!-- 颜色选择器 -->
<template>
  <div class="color-picker-box">
    <span class="color-picker-text">{{ color }}</span>
    <el-color-picker
      v-model="color"
      @change="handleColor"
      :disabled="disabled"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from "vue";

interface Props {
  value: string;
  disabled: boolean;
}

const emit = defineEmits<{
  (e: "updata:value", color: string): void;
}>();

const propsData = withDefaults(defineProps<Props>(), {
  value: "",
  disabled: false,
});

const color = ref("");

const handleColor = (value: string) => {
  color.value = value;
  emit("updata:value", value);
};

watch(
  () => propsData.value,
  (nweVal) => {
    console.log(nweVal);
    color.value = nweVal;
  },
  {
    immediate: true,
    deep: true,
  }
);
</script>
<style lang="scss" scoped>
.color-picker-box {
  position: relative;
  .color-picker-text {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
  }
}
</style>
